import { render, staticRenderFns } from "./_courseId.vue?vue&type=template&id=718bdecc&scoped=true&"
import script from "./_courseId.vue?vue&type=script&lang=js&"
export * from "./_courseId.vue?vue&type=script&lang=js&"
import style0 from "./_courseId.vue?vue&type=style&index=0&id=718bdecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718bdecc",
  null
  
)

export default component.exports